// 提示信息
export const tips = [
  '请核实司机身份证号、姓名、手机号是否正确；',
  '发起签署后，司机需 <b style="color: red">【打开司机端APP 登录，确认签署】</b>',
  '签约有效期 7 天，超时后需要重新发起。',
]
